import { render, staticRenderFns } from "./SegmentList.vue?vue&type=template&id=d7090836&"
import script from "./SegmentList.vue?vue&type=script&lang=js&"
export * from "./SegmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports